/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CancelPtTicketRequest as AgentApiContractCancelPtTicketRequest } from '../../models/AgentApi/Contract/cancel-pt-ticket-request';
import { CancelPtTicketResponse as AgentApiContractCancelPtTicketResponse } from '../../models/AgentApi/Contract/cancel-pt-ticket-response';

export interface ApiAgentCancelPtTicketPost$Params {

/**
 * * Interface language
 */
  lang?: string;
      body?: AgentApiContractCancelPtTicketRequest
}

export function apiAgentCancelPtTicketPost(http: HttpClient, rootUrl: string, params?: ApiAgentCancelPtTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCancelPtTicketResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentCancelPtTicketPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractCancelPtTicketResponse>;
    })
  );
}

apiAgentCancelPtTicketPost.PATH = '/api/Agent/CancelPtTicket';
